import { useCallback } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const api = axios.create({ baseURL: `${BACKEND}/api`, timeout: 4000 });

// Gera ou recupera um session_id único por aba/sessão
export const getSessionId = () => {
  let sid = sessionStorage.getItem("ld_session");
  if (!sid) {
    sid = crypto.randomUUID?.() ?? Math.random().toString(36).slice(2, 18);
    sessionStorage.setItem("ld_session", sid);
  }
  return sid;
};

export const getDevice = () => {
  const ua = navigator.userAgent;
  if (/Mobi|Android/i.test(ua)) return "mobile";
  if (/Tablet|iPad/i.test(ua)) return "tablet";
  return "desktop";
};

// Salva lead no localStorage local para garantia imediata
const saveLocalLead = (leadData) => {
  try {
    const raw = localStorage.getItem("ld_leads");
    const list = raw ? JSON.parse(raw) : [];
    const sid = leadData.session_id;
    const existingIdx = list.findIndex((l) => l.session_id === sid);

    const now = new Date().toISOString();
    const updated = {
      ...(existingIdx >= 0 ? list[existingIdx] : {}),
      ...leadData,
      updated_at: now,
      created_at: existingIdx >= 0 ? list[existingIdx].created_at : now,
    };

    if (existingIdx >= 0) {
      list[existingIdx] = updated;
    } else {
      list.unshift(updated);
    }
    localStorage.setItem("ld_leads", JSON.stringify(list));
  } catch (err) {
    console.warn("[lead-local]", err);
  }
};

const saveLocalEvent = (eventData) => {
  try {
    const raw = localStorage.getItem("ld_events");
    const list = raw ? JSON.parse(raw) : [];
    list.unshift({ ...eventData, created_at: new Date().toISOString() });
    localStorage.setItem("ld_events", JSON.stringify(list.slice(0, 300)));
  } catch (err) {
    console.warn("[event-local]", err);
  }
};

export const useLead = () => {
  const saveLead = useCallback(async (data) => {
    const fullLead = {
      session_id: getSessionId(),
      device: getDevice(),
      referrer: document.referrer || null,
      ...data,
    };

    // Sempre salva localmente primeiro (resiliência total)
    saveLocalLead(fullLead);

    // Envia ao backend se disponível
    try {
      await api.post("/leads", fullLead);
    } catch (e) {
      console.warn("[lead-api]", e.message);
    }
  }, []);

  const trackEvent = useCallback(async (step, action, value = null) => {
    const eventData = {
      session_id: getSessionId(),
      step,
      action,
      value,
    };

    saveLocalEvent(eventData);

    try {
      await api.post("/leads/event", eventData);
    } catch (e) {
      console.warn("[funnel-api]", e.message);
    }
  }, []);

  return { saveLead, trackEvent };
};
